import React from "react";

const RemarksHistory = ({ Remarks, hide }) => {
  return (
    <>
      <div className="col-md-12">
        <button
          className="btn-link btn-link--bold"
          type="button"
          onClick={() => hide("hide")}
        >
          Go Back
        </button>
      </div>
      <div className="col-md-12">
        <ul className="remarks__list">
          {Remarks?.map((item, index) => {
            return (
              <li className="remarks__item" key={index}>
                <div className="remarks__userdetails">
                  <h5>{item.created_by}</h5>
                  <h5>{item.created_on ? item.created_on.slice(0, 16) : ""}</h5>
                </div>
                <div className="remarks__reason">
                  <h5>Quotation Comments</h5>
                  <p>{item.quotation_comments}</p>
                </div>
                {/* <div className="remarks__userdetails">
                <p>Reschedule Date</p>
                <p>{item.work_request_reschedule_date}</p>
              </div> */}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default RemarksHistory;
